module.exports = __webpack_public_path__ + "9d349b5d23fd90fa4087da73f691806e.svg";